import { trackEvent } from "../utils/track-event";
import type { TrackingEvent, TrackingEventResponse } from "../utils/types";
import type { FeedbackFormAnsweredProps } from "./feedback-form-answered";

export type FeedbackFormCompletedProps = FeedbackFormAnsweredProps & {
  followUpQuestion: string;
  followUpAnswer: string;
};

export type FeedbackFormCompletedEvent = TrackingEvent<
  "Feedback Form Completed",
  {
    form_question: string;
    form_answer: string;
    follow_up_question: string;
    follow_up_answer: string;
  }
>;

export async function trackFeedbackFormCompletedEvent({
  question,
  answer,
  followUpQuestion,
  followUpAnswer,
}: FeedbackFormCompletedProps): TrackingEventResponse {
  return await trackEvent("Feedback Form Completed", {
    props: {
      form_question: question,
      form_answer: answer,
      follow_up_question: followUpQuestion,
      follow_up_answer: followUpAnswer,
    },
    withRequestSource: true,
  });
}
